var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer"
  }, [_c('v-container', [_c('div', {
    staticClass: "mb-12px mb-lg-24px"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('router-link', {
    staticClass: "txt txt--xs font-weight-medium white--text",
    attrs: {
      "to": "/disclaimer"
    }
  }, [_vm._v("면책공고")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "footer__line"
  })]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('router-link', {
    staticClass: "txt txt--xs font-weight-medium white--text",
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_vm._v("개인정보처리방침")])], 1)], 1)], 1), _c('p', {
    staticClass: "txt txt--xs grey--text text--lighten-1"
  }, [_vm._v("© 2025 Sage Law. All Rights Reserved")])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }